<template>
<div class="container">
  <div class="main-table" ref='mainTable'>
    <div class="table-body" :style="getLength">
         <table class="table" cellspacing="0" cellpadding="0">
           <tr>
             <td>行表头</td>
           </tr>
           <tr>
             <td>表达式</td>
           </tr>
            <tr>
             <td>汇总行</td>
           </tr>
         </table>
         <div class="table-width" ref='tableWidth'>
           <table class="table-list" cellspacing="0" cellpadding="0" >
             <thead>
              <tr>
                 <th v-for="(col, index) in columns"
                     class="table-header"
                     :key="index" :index="index" :id="col.id"
                     :name="col.name" :title="col.name"
                     @dragover="allowDrop" @drop.stop="drop"
                     draggable="true"
                     @dragstart="onDragStart($event, col)"
                     @dragend="onDragStop($event)"
                     @click.stop="openColumnAttr(col,index)"
                     :style="{'background':lock.currentIndex===index?'#def0ff':col.hidden?'rgba(0,0,0,.15)':'#fff'}">
                     <div v-if="index === lock.titleIndex">
                     <input
                       type="text" class="form-control"
                       @keyup.enter="addCusterColumn" v-focus="true"
                       v-model="col.name" :oldvalue="col.name"/>
                     <span class="buttons" plain type="mini" icon="el-icon-check" @click.stop="addCusterColumn"><i class="el-icon-check"></i></span>
                   </div>
                   <div v-if="index !== lock.titleIndex && copyReportService.report.mainTableId">
                     <i v-if="col.name" class="del-column" @click.stop="delColumn(index,col.id)">x</i>
                     <i v-if="col.name" @click.stop="move(index, 'left')" class="el-icon-arrow-left move" title="左移"></i>
                     <el-dropdown trigger="click" @command="handleCommand">
                      <span v-if="col.name" class="el-dropdown-link">
                        <label >{{ col.name }}</label>
                      </span>
                       <span v-else class="add-column">
                        <label></label>
                      </span>
                       <el-dropdown-menu slot="dropdown">
                         <el-dropdown-item v-if="!col.name" :command="{'type': 'rename', 'index': index}">增加</el-dropdown-item>
                       </el-dropdown-menu>
                     </el-dropdown>
                     <i v-if="col.name" @click.stop="move(index, 'right')" class="el-icon-arrow-right move" title="右移"></i>
                   </div>
                  </th>
              </tr>
             </thead>
             <tbody>
              <tr id="fieldData">
                <td v-for="(col,index) in columns" :key='index'
                    @dblclick="calculateAppear(index,col.name,col.id)"
                    v-html='getReportColumnName(col.expressionText)'
                    :title='getFormulaTip(col.expressionText)'>
                </td>
              </tr>
             </tbody>
             <tbody>
              <tr id="fieldData-summary">
                <td v-for="(col,index) in columns" :key='index'>
                  <el-checkbox v-if="col.id" :value="!!col.summary" @change='summaryAppear(index,col.name)'></el-checkbox>
                </td>
              </tr>
             </tbody>
           </table>
           <freeze-lock :columns="columns"></freeze-lock>
         </div>
    </div>
    <div class="table-option" v-if="!copyReportService.report.dataSourceReport">
      <table class="table" cellspacing="0" cellpadding="0">
        <thead>
          <tr>
            <td class="operation-td">
              <span class="operation-line">操作列</span>
              <span :class="['el-icon-sort', getButtons('update').length <= 1 ? 'disabled-sort': '']" @click="sortButtons"></span>
              <span :class="['el-icon-plus', this.getButtons('update').length === 24 ? 'disabled-sort': '']" @click="addButtons('update')"></span>
            </td>
          </tr>
        </thead>
          <tbody>
            <tr>
                <td rowspan='2'>
                   <report-button-component ref="reportButtonComponent" :type="'dataButton'"></report-button-component>
                </td>
            </tr>
            <tr>
            </tr>
          </tbody>
      </table>
    </div>
  </div>
  <!-- 出现排序的模态框 -->
  <el-dialog title="拖动排序"
             :visible.sync="page.centerDialogVisible"
             width="932px"
             center
             class="dialog-of-sort"
             :close-on-click-modal="false"
             @close="clearCurrentClick"
             append-to-body>
      <div class="modal-body">
        <ul class="modal-body-ul">
          <draggable v-model="sortColumns">
            <transition-group>
                <li class="modal-body-li"
                      v-for="(col,index) in sortColumns"
                      :key='index'
                      @click="page.isClick=col.id" :class="{'select-li':page.isClick===col.id}">
                    <div class="column-name" :title="col.name">{{col.name}}</div>
                    <span class="el-icon-error delete" @click="delSortColumn(index)"></span>
                  </li>
            </transition-group>
          </draggable>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveColumn">确 定</el-button>
        <el-button @click="page.centerDialogVisible = false">取 消</el-button>
      </span>
  </el-dialog>
</div>
</template>

<script>
import Draggable from 'vuedraggable'
import Column from '@/store/report/column'
import CalculationPanel from '../../shared/calculation-panel.vue'
import FreezeLock from './freeze-lock.vue'
import ReportButtonComponent from './report-button-component.vue'
import ColorFormat from '@/store/report/colorFormat.js'
import DisplayFormat from '@/store/report/displayFormat.js'
import DataFormat from '@/store/report/dataFormat.js'
export default {
  inject: ['reportService'],
  props: ['report'],
  name: 'main-definition-table',
  components: {
    CalculationPanel,
    FreezeLock,
    ReportButtonComponent,
    Draggable
  },
  data () {
    return {
      page: {centerDialogVisible: false, isClick: ''},
      position: {layerX: 0, layerY: 0},
      lock: {currentIndex: -1, titleIndex: -1},
      sortColumns: [],
      calculationPanelData: {tables: [], index: 0, expression: '', optionalFunctionValue: ['simple', 'math', 'text', 'date'], type: true},
      operationPosition: true,
      dialogVisible: false,
      countAllColumns: 0,
      copyReportService: {}
    }
  },
  created () {
    this.copyReportService = this.$_.cloneDeep(this.reportService)
  },
  watch: {
    'copyReportService.report.mainTableId' () {
      this.columns = this.$_.cloneDeep(this.reportService.report.columns)
      this.addSortField()
    },
    reportService: {
      handler (val) {
        this.copyReportService = this.$_.cloneDeep(this.reportService)
      },
      deep: true
    },
    'copyReportService.options.leftPanel': {
      handler (val, old) {
        if (val && val.type !== 'column-panel' && old && old.type === 'column-panel') {
          this.columns = this.$_.cloneDeep(this.reportService.report.columns)
          this.lock.currentIndex = -1
        }
      },
      deep: true
    }

  },
  computed: {
    columns: {
      get () {
        let columns = []
        columns = this.$_.cloneDeep(this.copyReportService.report.columns)
        // column不够5列时，自动补全5列展示
        let columnsLength = columns.length
        // 如果是辅助表，则有6个
        let length = this.copyReportService.report.dataSourceReport ? 6 : 6
        if (columnsLength < length) {
          for (let i = 0; i < length - columnsLength; i++) {
            columns.push({})
          }
        } else {
          columns.push({})
        }
        return columns
      },
      set (value) {
        this.copyReportService.report.columns = value
      }
    },
    getLength () {
      return this.copyReportService.report.dataSourceReport ? {width: '100%'} : {width: 'calc(100% - 152px)'}
    },
    getButtons () {
      return type => {
        let createButtons = []
        let columnButtons = []
        let buttons = this.$_.cloneDeep(this.reportService.report.buttons)
        // 判断按钮是新建还是非新建按钮，新建的按钮则是表格上面一列的
        buttons.forEach(m => {
          if (['create', 'import', 'export', 'print', 'custom-top', 'import-action', 'logic'].some(n => n === m.type)) {
            createButtons.push(m)
          } else {
            columnButtons.push(m)
          }
        })
        return type === 'update' ? columnButtons : createButtons
      }
    }
  },
  methods: {
    drop (event) {
      let tableColumn = JSON.parse(event.dataTransfer.getData('text'))
      if (tableColumn && tableColumn.type === 'table') {
        let sort = event.currentTarget.cellIndex
        let reportColumn = Column.create(tableColumn, sort)
        let colorFormat = new ColorFormat()
        reportColumn.format.colorFormats.push(colorFormat)
        let displayFormat = new DisplayFormat()
        reportColumn.format.displayFormats.push(displayFormat)
        reportColumn.format.dataFormat = new DataFormat()
        reportColumn.columnType = tableColumn.dataType || tableColumn.columnType
        this.reportService.createOrUpdate(reportColumn)
      }
    },
    summaryAppear (index, columnName) {
      let _this = this
      this.$Popup.calculation({
        parameter: {
          title: '汇总属性',
          expression: _this.reportService.report.columns[index].summary || '',
          dataSource: _this.reportService.getReportJoinTables(),
          functionType: ['simple', 'math', 'text', 'date', 'logic', 'concat', 'system'],
          calculationType: 'sql'
        },
        width: '1000px'
      }).then((data) => {
        if (data.action === 'confirm') {
          _this.reportService.report.columns[index].summary = data.value
        }
      })
    },
    calculateAppear (index, columnName, id) {
      let _this = this
      let groupByEnable = this.reportService.report.groupByEnable
      let functionType = ['simple', 'math', 'text', 'date', 'logic']
      if (groupByEnable) {
        let column = this.reportService.report.groupBies.find(m => m.columnId === id)
        if (!column) {
          functionType = ['simple', 'math', 'text', 'date', 'concat', 'logic']
        }
      }
      // 点击空列会报错
      _this.reportService.report.columns[index] && this.$Popup.calculation({
        parameter: {
          title: '表达式设计',
          expression: _this.reportService.report.columns[index].expressionText || '',
          dataSource: _this.reportService.getReportJoinTables(),
          functionType: functionType,
          calculationType: 'sql'
        },
        width: '1000px'
      }).then((data) => {
        if (data.action === 'confirm') {
          _this.reportService.report.columns[index].expressionText = data.value
        }
      })
    },
    allowDrop (event) {
      event.preventDefault()
    },
    delSortColumn (index) {
      // 排序中的假删除
      this.deleteTip(() => {
        this.sortColumns.splice(index, 1)
      })
    },
    scrollRight () {
      this.$nextTick(() => {
        let tableWidth = this.$refs.tableWidth
        if (tableWidth.scrollWidth > tableWidth.clientWidth) {
          tableWidth.scrollLeft = tableWidth.scrollWidth - tableWidth.clientWidth
        }
      })
    },
    // 表头点击事件
    handleCommand (command) {
      if (this.copyReportService.report.mainTableId) {
        let type = command.type
        this.lock.currentIndex = command.index
        switch (type) {
          case 'rename':
            this.rename()
            break
          default:
            break
        }
      }
    },
    rename () {
      this.lock.titleIndex = this.lock.currentIndex
    },
    addCusterColumn () {
      let column = this.columns[this.lock.currentIndex]
      if (column.name === '' || !column.name) {
        if (column instanceof Column) {
          this.$message.info('列名不能为空')
        }
      } else {
        if (!(column instanceof Column)) {
          column = Column.create({name: column.name}, this.lock.currentIndex)
        }
        this.reportService.createOrUpdate(column)
      }
      this.lock.titleIndex = -1
    },
    sortColumn () {
      this.sortColumns = this.$_.cloneDeep(this.reportService.report.columns)
      this.page.centerDialogVisible = true
    },
    openColumnAttr (column, index) {
      if (column instanceof Column && column.name) {
        this.lock.currentIndex = index
        this.reportService.openPanel(column.id, 'column-panel')
      }
    },
    delColumn (index, id) {
      if (this.reportService.options.leftPanel.id === id) {
        this.reportService.closePanel()
      }
      this.deleteTip(() => {
        this.reportService.delete(this.columns[index])
      })
    },
    deleteTip (calllback) {
      this.$confirm('请确认该列没有被引用再删除哦', '', {
        confirmButtonText: '取消',
        cancelButtonText: '确定',
        customClass: 'deleMessageBox',
        distinguishCancelAndClose: true,
        center: true
      }).then(() => {
      }).catch((action) => {
        if (action === 'cancel') {
          calllback()
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        }
      })
    },
    // 左右移动
    move (index, type) {
      let length = this.columns.length
      if (type === 'left') {
      // 左移
        if (index > 0) {
          this.lock.currentIndex = this.lock.currentIndex === -1 ? -1 : index - 1
        }
      } else {
      // 右移
        if (index < length && index !== (length - 1)) {
          this.lock.currentIndex = this.lock.currentIndex === -1 ? -1 : index + 1
        }
      }
      this.reportService.moveColumn(index, type)
      this.$nextTick(() => {
        let tableWidth = this.$refs.tableWidth
        if (tableWidth.scrollWidth > tableWidth.clientWidth) {
          if (type === 'left') {
            tableWidth.scrollLeft = tableWidth.scrollLeft - 190
          } else {
            tableWidth.scrollLeft = tableWidth.scrollLeft + 190
          }
        }
      })
    },
    saveColumn () {
      let userds = this.reportService.checkUserds(this.sortColumns)
      let userArr = []
      this.page.centerDialogVisible = false
      if (userds.length > 0) {
        userds.forEach(m => {
          userArr.push(m.name)
        })
        userArr = userArr.toString()
        this.$confirm('', '检查到' + userArr + '被条件、分组或排序引用，确认删除？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'deleMessageBox',
          center: true
        }).then(() => {
          // 若该列被引用出现弹窗，点击确定删除
          this.reportService.saveSortOfColumns(this.sortColumns)
          this.$message({
            type: 'success',
            message: '保存成功!'
          })
        })
      } else {
        this.reportService.saveSortOfColumns(this.sortColumns)
      }
    },
    // 拖拽到筛选面板
    onDragStart (event, col) {
      this.reportService.dragFilter(true)
      col.type = 'report'
      col.mouseOffset = {
        x: event.offsetX,
        y: event.offsetY,
        width: event.target.offsetWidth,
        height: event.target.offsetHeight
      }
      event.dataTransfer.setData('text', JSON.stringify(col))
    },

    onDragStop (event) {
      this.reportService.dragFilter(false)
    },
    // 每次表达式变化，都把子组件改变后的表达式在这里转化成标签，展示在表格中
    getReportColumnName (formula) {
      if (formula) {
        formula.match(/\$\{(.+?)\}/g) && formula.match(/\$\{(.+?)\}/g).map(el => {
          let codeAttr = el.replace(/[${}]/g, '').split(',')
          let code = `&nbsp;<span contenteditable='false' dataId=${codeAttr[0]} name=${codeAttr[1]} type=${codeAttr[2]}>${codeAttr[1]}</span>&nbsp;`
          formula = formula.replace(el, code)
        })
        return formula
      }
    },
    // 鼠标移入表达式会出现全部表达式
    getFormulaTip (tip) {
      if (tip) {
        tip.match(/\$\{(.+?)\}/g) && tip.match(/\$\{(.+?)\}/g).map(el => {
          tip = tip.replace(el, el.replace(/[${}]/g, '').split(',')[1])
        })
        return tip
      }
    },
    clearCurrentClick () {
      this.page.isClick = ''
    },
    addButtons (type) {
      // 添加按钮
      if (this.getButtons('update').length >= 24) {
        return false
      }
      this.$refs.reportButtonComponent.addButton(type)
    },
    sortButtons () {
      if (this.getButtons('update').length <= 1) {
        return false
      }
      this.$refs.reportButtonComponent.openDialog(this.getButtons('update'))
    },
    // 为所有的按钮添加sort字段
    addSortField () {
      let createIndex = -1
      let columnIndex = -1
      let buttons = this.reportService.report.buttons
      if (buttons && buttons.length) {
        buttons.forEach(b => {
          // 新建按钮
          if (['create', 'import', 'export', 'print', 'custom-top'].some(n => n === b.type)) {
            b.sort = ++createIndex
          } else {
            b.sort = ++columnIndex
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.container {
  &::after {
    // 清除父元素的塌陷问题
    content: '';
    display: block;
    clear: both;
  }
  .main-table {
    font-size: 14px;
    position: relative;
    &:after {
      content: "";
      display: block;
      clear: both;
    }
    .table-body {
      float: left;
      padding-left: 100px;

      .table-width {
        overflow: auto;
        width: 100%;
        border-left-style: none;

        .table-list {
          width: 100%;
          overflow-x: scroll;
          border-right: 1px solid #ebeef5;
          border-top: none;
          th,
          td {
            max-width: 190px;
            min-width: 190px;
            height: 42px;
            border: 1px solid #ebeef5;
            border-right-style: none;
            text-align: center;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .table-header {
             position: relative;
             .del-column {
               position: absolute;
               right: 4px;
               top: 4px;
               visibility: hidden;
               width: 10px;
               height: 10px;
               font-size: 7px;
               border-radius: 50%;
               background: transparent;
               text-align: center;
               line-height: 8px;
               cursor: pointer;
               font-style: normal;
               color: #C2C3C4;
               font-weight: 400;
               &:hover {
                 background: #FB9391;
                 color: #fff;
               }
               &:active {
                 background: #EE5451;
                 color: #fff;
               }
             }
              .el-dropdown-link {
              color: #54abf1;
              &:focus {
                outline: none;
                border: none;
              }
              >label {
                max-width: 80px;
                overflow: hidden;
                white-space: nowrap;
                display: inline-block;
                text-overflow: ellipsis;
                padding-top: 5px;
              }
            }
            .add-column {
              >label {
                display: inline-block;
                width: 100px;
              }
            }
            color: #54abf1;
            i {
              cursor: pointer;
            }
            i.hidden {
              display: none;
            }
            .el-icon-caret-bottom {
              padding-left: 0;
              vertical-align: middle;
              margin-top: -22px;
            }
            .move {
              visibility: hidden;
              position: absolute;
              top: 14px;
              &.el-icon-arrow-left{
                left: 24px;
              }
               &.el-icon-arrow-right{
                right: 24px;
              }
            }
            .down{
               visibility: hidden;
            }
          }
          .table-header:hover {
            background: #f1f9ff !important;
            .move {
              visibility: visible;
            }
            .down{
               visibility: visible;
            }
            .del-column {
               visibility: visible;
            }
          }
          .form-control {
            width: 60%;
            height: 28px;
            text-align: center;
            box-shadow: none;
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
            border: 1px solid #dcdfe6;
            border-right: none;
          }
          .buttons {
            margin-left: -4px;
            height: 28px;
            color: #409eff;
            display: inline-block;
            width: 24px;
            border: 1px solid #dcdfe6;
            vertical-align: top;
            line-height: 24px;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
          }
          input:focus {
            outline: none;
          }
        }
      }
      .table {
        width: 95px;
        margin-left: -95px;
        text-align: center;
        float: left;
        border-bottom: 1px solid #ebeef5;
        td {
          height: 42px;
          border-top: 1px solid #ebeef5;
          border-bottom: 1px solid #ebeef5;
        }
      }
    }
    .table-option {
      width: 150px;
      float: left;
      background-color: #fff;
      .table {
        border: none;
        width: 100%;
        td{
          border: 1px solid #ebeef5;
        }
        tr{
          height: 42px;
          text-align: center;
          .el-icon-sort, .el-icon-plus {
            color: #55ABF1;
            font-size: 16px;
            cursor: pointer;
          }
          .el-icon-sort {
            margin-left: 10px;
          }
          .disabled-sort {
            color: #C2C3C4;
          }
        }
        .operation-td {
          padding-left: 15px;
          .el-icon-plus,.el-icon-sort {
            font-size: 16px;
            &:active{
              color: #388DD2
            }
          }
          .disabled-sort.el-icon-sort {
            &:hover,&:active {
              color: #C2C3C4;
            }
          }
        }
        .fixFirstColumn{
          margin-left: 12px;
          .el-checkbox__label {
            color: #606266;
          }
        }
      }
    }
  }
}
.dialog-of-sort {
    .el-dialog {
      min-width: 386px;
      .el-dialog__body {
        padding: 20px 10px 20px 25px;
      }
      .modal-body {
        position: relative;
        overflow-y: auto;
        min-height: 121px;
        max-height: 514px;

        .modal-body-ul {
          li {
            margin: 9px auto;
            position: relative;
            width: 110px;
            height: 42px;
            line-height: 42px;
            cursor: pointer;
            float: left;
            border: 1px solid #EBEBEB;
            border-left: none;
            &:nth-of-type(8n+1){
              border-left: 1px solid #EBEBEB;
            }
            &:hover {
              background: #E3F1FE;
              .delete {
                 display: inline-block;
              }
            }

            .column-name {
              padding-left: 8px;
              width:97px;
              text-align: center;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            span {
              position: absolute;
              right: 0;
              font-size: 13px;
              top: -7px;
              z-index: 2;
              display: none;
            }
            .delete{
              color: #CBCBCB;
              right: -8%;
            }
            .delete:active {
              color: #EE5757;
            }
            .delete:hover{
              color: #FB9391;
            }
            &.sortable-ghost,&.sortable-chosen{
              background: #CEE2FA;
            }
            &.select-li {
              background: #CEE2FA;
            }
          }
        }
      }
      .el-button {
        padding: 5px 24px;
      }
    }
  }
.el-message-box.deleMessageBox {
  .el-message-box__btns {
    .el-button {
      width: 104px;
      height: 30px;
      padding: 0;
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      &.el-button--primary {
        color: #409eff;
        background-color: #fff;
        border-color: #409eff;
        margin-left: 49px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/report/design/main-definition-table.vue